import { Grid, Pagination, Skeleton } from "@mui/material"
import { useEffect } from "react"
import { useState } from "react"
import KnowledgeBaseCard from "./knowledgebasecard";
import { FormattedMessage } from "react-intl";
import { PapiroConsole } from "src/utils/papiroConsole";
import Api from "src/services/api";
import DialogGeneral from "src/components/dialog-general";
import KnowledgeBaseDetailDialog from "src/components/details-dialogs/knowledgebase-detail-dialog";

const LlmDocumentKnowledgeBasesList = (props) => {
    const { intl, onShowNotification, onLoading, loading, refresh } = props

    const [knowledgeBaseLlmDocuments, setKnowledgeBaseLlmDocuments] = useState([])
    const [pageLlmDocument, setPageLlmDocument] = useState(1)
    const [totalLlmDocument, setTotalLlmDocument] = useState(0)
    const [totalPagesLlmDocument, setTotalPagesLlmDocument] = useState(0)
    const [pageStartLlmDocument, setPageStartLlmDocument] = useState(0)
    const [pageEndLlmDocument, setPageEndLlmDocument] = useState(10)
    const [open, setOpen] = useState(false)
    const [openKnowledgeBaseDelete, setOpenKnowledgeBaseDelete] = useState(false)
    const [knowledgeBaseSelectedDelete, setKnowledgeBaseSelectedDelete] = useState(null)
    const [knowledgeBaseSelected, setKnowledgeBaseSelected] = useState(null)
    const [knowledgeBaseDetailItem, setKnowledgeBaseDetailItem] = useState(null)

    const openKnowledgeBaseDetail = (knowledgeBase) => setKnowledgeBaseDetailItem({
        id: knowledgeBase.id,
        type: 'knowledgebase',
        knowledgeBaseId: knowledgeBase.id,
        title: knowledgeBase.title || '',
        displayTitle: knowledgeBase.title || '',
        createdusername: knowledgeBase.createdusername || '',
        createddate: knowledgeBase.createdat || '',
    })

    const closeKnowledgeBaseDetail = () => setKnowledgeBaseDetailItem(null)
    useEffect(() => {
        getKnowledgeBases()
    }, [refresh])

    useEffect(() => {
        getKnowledgeBases()
    }, [refresh])

    const getKnowledgeBases = async (page = 1) => {
        let url = `/knowledgebases/paginate?page=${page}`;

        // let newFilter = localStorage.getItem('newFilter');
        // let newSearch = localStorage.getItem('newSearch');
        // if (newFilter != '' && newSearch != '') {
        //     url += `&search=${newSearch}&field=${newFilter}`;
        //     this.setState({ dataFilter: true });
        // }
        url += `&llmdocument=true`
        onLoading(true)
        await Api.get(url)
            .then((response) => {
                if (response) {
                    setTotalLlmDocument(response.data?.count)
                    setPagination(response.data?.count, page)
                    setKnowledgeBaseLlmDocuments(response.data.data)
                } else {
                    const message = response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    onShowNotification(message, 'error')
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "process.error" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const setPagination = (count, page) => {
        setTotalPagesLlmDocument(Math.ceil(count / 10))
        const start = count > 0 ? (page - 1) * 10 + 1 : 0
        setPageStartLlmDocument(start)
        setPageEndLlmDocument(Math.min(start + 9, count))
    }

    const onChangePaginate = (event, value) => {
        setPageLlmDocument(value)
        getKnowledgeBases(value)
    }

    const onOpenKnowledgeBase = (file) => {
        PapiroConsole.log("open knowledge base")
    }

    const onDelete = async () => {
        let url = `/llmdocumentknowledgebases/${knowledgeBaseSelectedDelete.id}`
        onLoading(true)
        await Api.delete(url)
            .then(async (response) => {
                if (response) {
                    await getKnowledgeBases(pageLlmDocument)
                } else {
                    const message = response.data && response.data.response && response.data.response.data && response.data.response.data.errors && response.data.response.data.errors[0] ? response.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
                    onShowNotification(message, 'error')
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "process.error" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    return (
        <>
            {loading ? (
                <Grid container spacing={1.25}>
                    {Array.from({ length: 6 }).map((_, i) => (
                        <Grid item xs={12} sm={6} md={4} key={i}>
                            <Skeleton variant="rounded" height={160} />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Grid container paddingTop={2} spacing={1.25}>
                    {knowledgeBaseLlmDocuments.map((item) => (
                        <Grid item xs={12} sm={6} md={4} key={item.id}>
                            <KnowledgeBaseCard
                                item={item}
                                onClick={_ => {
                                    setKnowledgeBaseDetailItem(item)
                                    // setOpen(true)
                                }}
                                onDelete={_ => {
                                    setKnowledgeBaseSelectedDelete(item)
                                    setOpenKnowledgeBaseDelete(true)
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            )}

            <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                    <Pagination count={totalPagesLlmDocument} page={pageLlmDocument} onChange={onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {pageStartLlmDocument} {<FormattedMessage id="to" />} {pageEndLlmDocument} {<FormattedMessage id="of" />} {totalLlmDocument} {<FormattedMessage id="register" />}
                </Grid>
            </Grid>

            <KnowledgeBaseDetailDialog
                open={!!knowledgeBaseDetailItem}
                onClose={closeKnowledgeBaseDetail}
                item={knowledgeBaseDetailItem}
                intl={intl}
                setMessage={(isOpen, variant, message) => {
                    if (isOpen) {
                        onShowNotification(message, variant)
                    }
                }}
            />

            <DialogGeneral
                intl={intl}
                dialogTitle={knowledgeBaseSelectedDelete?.id + " - " + knowledgeBaseSelectedDelete?.title}
                dialogSubTitle="Você realmente deseja remover este base de conhecimento da llm?"
                open={openKnowledgeBaseDelete}
                openOrCloseModalFunction={setOpenKnowledgeBaseDelete}
                handleConfirmation={onDelete}
            />
        </>
    )
}

export default LlmDocumentKnowledgeBasesList